export default __webpack_public_path__ + "static/media/trash.b245e5b5.svg";